/** Relative to origin; `useAxios` prepends `/api` via ensureApiPrefix. */
export const bookkeepingWaitlistApiPath = (customerDomain: string) => `/${customerDomain}/bookkeeping/api/waitlist`;
